import { createFileRoute } from '@tanstack/react-router';
import { ImapScreen } from '../../../features/settings/imap-screen';
import { SmtpScreen } from '../../../features/settings/smtp-screen';

/**
 * Configurarea emailului: **trimiterea** (SMTP) și **citirea** (IMAP).
 *
 * Sub `/setari`, dar cu ecrane și rute proprii, nu ca rânduri în „Setările aplicației":
 * parolele nu pot trece pe drumul generic, care întoarce toate valorile către browser și
 * scrie diferențele în jurnal. Vezi `crm_smtp_settings` și `crm_imap_settings`.
 *
 * Amândouă pe aceeași pagină pentru că amândouă răspund la „cum vorbește CRM-ul prin
 * email"; două rute ar fi cerut operatorului să știe dinainte care din ele e stricată.
 */
export const Route = createFileRoute('/_authenticated/setari/email')({
  component: EmailSettingsPage,
});

function EmailSettingsPage() {
  return (
    <div className="flex flex-col gap-y-6">
      <SmtpScreen />
      <ImapScreen />
    </div>
  );
}
